import { Injectable } from '@angular/core';
import { DBService } from './db.service';
@Injectable()
export class ScoreService {
  grouped: any = {};
  distinct_kidneys: any = [];

  constructor(private db: DBService) { }

  //Queries the scores collection for a specific user
  //and returns the results in a dictionary, keyed by kidney_id
  groupScoresByKidney(uid: string, callback) {
  
    this.db.getCollection('scores', true, ref => ref
      .where('user_uid', '==', uid)
      .orderBy('date', 'desc'))
      /*
    .map((score:any) => {
      score["kidney$"] =this.db.afs.doc('kidneys/'+score.kidney_id).snapshotChanges();
      return score;
    })*/
     .subscribe((userScores:any) => {
      this.grouped = {};
      this.distinct_kidneys = [];
      
      userScores.forEach((score:any) => {

        //If first score for that kidney, async load the kidney details
        if (!this.grouped[score.kidney_id]) {
          this.grouped[score.kidney_id] = [];
          this.distinct_kidneys.push(this.grouped[score.kidney_id])
        }
        //Add the score to the appropriate bucket
        this.grouped[score.kidney_id].push(score);
      });
      console.log("ScoreService 29: grouped scores are ready");
      callback();
    });
  }

  calcByType(surgery_type, allScores) {
    let scores = allScores.filter(x => { return ( x[surgery_type].total) });
    if (scores.length == 0) 
      return {};
    

    let avg = {}
    Object.keys(scores[0][surgery_type]).forEach((key) => {
        let subscore_items = scores.map(x => x[surgery_type][key]);
        let subscore_item_count = scores.length;
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        let sum = subscore_items.reduce(reducer);
        avg[key] = Math.round(sum / subscore_item_count);
    });
    return avg;
  }

  getBest(surgery_type, allScores) {
    let scores = allScores.filter(x => { return ( x[surgery_type].total) });
    if (scores.length == 0) 
      return {};

    let t = {}
    Object.keys(scores[0][surgery_type]).forEach((key) => {
      let subscore_items = scores.map(x => { return x[surgery_type][key] });
        let subscore_item_count = scores.length;
        const comparator = (a, b) => b - a;
        subscore_items.sort(comparator);
        t[key] = subscore_items[0];
    });

    return t;

  }

  calculateAverages(kidney_id) {
    //TODO: move to a cloud function triggered on scores insert
    this.db.afs.doc("kidneys/"+kidney_id).ref.get().then(doc => { 
      let kidney = doc.data()
      this.db.getCollection('scores', true, ref => ref
      .where('kidney_id', '==', kidney_id))
      .subscribe((scores: any) => {
        this.db.update("kidneys/"+kidney_id, {
                      averages : {
                        needle: this.calcByType("needle", scores),
                        wire: this.calcByType("wire", scores)
                      },
                     best: {
                       needle: this.getBest("needle", scores),
                       wire: this.getBest("wire", scores)
                     }}, false);
          
        });
      });
  }

  init(user_uid: string, callback) {
    console.log("Score service initializing. Subscribing to groupScoresByKidney for uid "+user_uid);
    this.groupScoresByKidney(user_uid, callback);
  }

}





// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/core/services/score.service.ts